import { createContext, useEffect, useState } from "react";
import {
    getAuth,
    onAuthStateChanged,
    signInWithEmailAndPassword,
    sendPasswordResetEmail,
    GoogleAuthProvider,
    signInWithPopup,
    signOut
} from 'firebase/auth';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

    const auth = getAuth();
    const [user, setUser] = useState(null)

    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                setUser(user);
            } else {
                setUser(false);
            }
        });
    }, [])

    const signIn = (email, password) => {
        return signInWithEmailAndPassword(auth, email, password);
    }

    const resertPassword = (email) => {
        return sendPasswordResetEmail(auth, email);
    }

    const googleSignIn = () => {
        const provider = new GoogleAuthProvider();
        auth.languageCode = 'es';
        return signInWithPopup(auth, provider);

    }

    const logOut = () => {
        return signOut(auth);
    }

    return (
        <AuthContext.Provider
            value={{ user, signIn, resertPassword, googleSignIn, logOut }}
        >
            {children}
        </AuthContext.Provider>
    )
}